// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/context-menu","wrapper":"context-menu-m__wrapper__2mvoX","contentWrapper":"context-menu-m__contentWrapper__GWUcS"};